module.exports = __webpack_public_path__ + "assets/img/jp_15.cff5272e.jpg";